/* COD Form v3 — CodStoreDz layout
   Sends orders to the Google Apps Script (same field names as v2), plus:
   wilaya dropdown, product subtotal, variants, gallery, sticky bars.
   Everything is inside one IIFE so nothing leaks into (or clashes with) the
   global scope of apps / other theme scripts. */
(function () {
  'use strict';

  var CFG = window.COD_CFG || {};
  var APPS_SCRIPT_URL = CFG.appsScriptUrl || window.APPS_SCRIPT_URL;
  // The second door: when the order site does not answer within 8 s (down, very slow, broken), the same order
  // goes straight to this Google Apps Script (same Sheet1). Only a Google Apps Script link is accepted here.
  var BACKUP_URL = /^https:\/\/script\.google\.com\/macros\/s\/[A-Za-z0-9_-]+\/exec$/.test(String(CFG.backupUrl || '')) ? String(CFG.backupUrl) : '';
  var BACKUP_AFTER = 8000;
  var THANKYOU_URL = CFG.thankyouUrl || window.THANKYOU_URL || '/pages/thankyou';

  var form = document.forms['google-sheet'];
  var btn = document.getElementById('btnSubmitMain');
  if (!form || !btn) return;

  var $ = function (id) { return document.getElementById(id); };
  var phoneInput = $('SaPhone');
  var phoneMsg = $('phoneMessage');
  var wilayaEl = $('Wilaya');
  var btnHTML = btn.innerHTML;
  var initiallyAvailable = btn.getAttribute('data-initial-available') !== 'false';
  var formSubmitted = false, submissionConfirmed = false;
  var controlsBeforeSubmit = [];
  var activeOrder = null;
  var restoringOrder = false;
  var productPage = form.closest('.cod-page');
  function updateEditingState() {
    if (!productPage) return;
    var focused = document.activeElement;
    var editing = focused && form.contains(focused) && /^(INPUT|SELECT|TEXTAREA)$/.test(focused.tagName) && focused.type !== 'hidden';
    productPage.classList.toggle('is-editing-order', !!editing);
  }
  form.addEventListener('focusin', updateEditingState);
  form.addEventListener('focusout', function () { setTimeout(updateEditingState, 0); });

  function fmt(n) {
    // "2 900 دج" — NBSP thousands separator, wrapped in a bidi isolate so the
    // digit groups never swap places inside RTL text.
    var v = Math.round(Number(n) || 0);
    var LRI = String.fromCharCode(0x2066), PDI = String.fromCharCode(0x2069), NBSP = String.fromCharCode(0xA0);
    return LRI + String(v).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP) + PDI + ' دج';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /*********** State ***********/
  var unitPrice = parseFloat(($('SaUnitPrice') || {}).value) || 0;
  var comparePrice = 0;
  var currentQty = 1;
  var currentVariant = null;

  /*********** Auto-fill from URL params (retargeting links) ***********/
  (function autoFillFromURL() {
    try {
      var params = new URLSearchParams(window.location.search);
      var map = {
        name: 'Sa-Name', fname: 'Sa-Name', first_name: 'Sa-Name',
        phone: 'Sa-Phone', tel: 'Sa-Phone',
        wilaya: 'Sa-Wilaya', city: 'Sa-Wilaya',
        address: 'Sa-Address', addr: 'Sa-Address'
      };
      Object.keys(map).forEach(function (key) {
        var val = params.get(key);
        var el = form.elements[map[key]];
        if (!val || !el || el.value) return;
        if (el.tagName === 'SELECT') {
          for (var i = 0; i < el.options.length; i++) {
            if (el.options[i].value === val) { el.value = val; break; }
          }
        } else {
          el.value = val;
        }
      });
    } catch (e) {}
  })();

  /*********** Enter jumps to the next field ***********/
  (function smartFormFlow() {
    var inputs = form.querySelectorAll('input:not([type=hidden]):not([type=radio]):not([tabindex="-1"]), select');
    Array.prototype.forEach.call(inputs, function (el, idx) {
      el.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        var next = inputs[idx + 1];
        if (next) next.focus(); else btn.focus();
      });
    });
  })();

  /*********** Prices + special offers ***********/
  // An offer = pieces received (data-qty), pieces paid (data-paid) and an
  // optional fixed total (data-price, 0 = paid × current unit price).
  var currentOffer = null;
  function offerTotal(r) {
    var fixed = parseFloat(r.getAttribute('data-price')) || 0;
    return fixed > 0 ? fixed : unitPrice * (parseFloat(r.getAttribute('data-paid')) || 1);
  }
  function productTotal() {
    return currentOffer ? offerTotal(currentOffer) : unitPrice * currentQty;
  }

  /*********** Merchant-configured delivery quote, in DZD ***********/
  function asciiDigits(value) {
    return String(value == null ? '' : value).replace(/[٠-٩]/g, function (c) { return c.charCodeAt(0) - 0x660; })
      .replace(/[۰-۹]/g, function (c) { return c.charCodeAt(0) - 0x6F0; });
  }
  function deliveryAmount(value) {
    var text = asciiDigits(value).trim();
    // Missing, negative or malformed rates must never silently mean free.
    if (!/^\d+$/.test(text)) return null;
    var amount = Number(text);
    return Number.isSafeInteger(amount) && amount >= 0 ? amount : null;
  }
  function deliveryKey(value) {
    var key = asciiDigits(value).trim();
    return /^\d+$/.test(key) ? String(Number(key)) : key;
  }
  function parseDeliveryRates(value) {
    var rates = Object.create(null);
    String(value || '').split(/\r?\n/).forEach(function (line) {
      if (!line.trim()) return;
      var separator = line.indexOf('=');
      if (separator < 0) return;
      var key = deliveryKey(line.slice(0, separator));
      if (key) rates[key] = deliveryAmount(line.slice(separator + 1));
    });
    return rates;
  }
  function parseUnavailable(value) {
    return asciiDigits(value).split(/[,،;\r\n]+/).map(deliveryKey).filter(Boolean);
  }
  var deliveryRates = { home: parseDeliveryRates(CFG.deliveryRates), desk: parseDeliveryRates(CFG.deliveryDeskRates) };
  var defaultDelivery = { home: deliveryAmount(CFG.deliveryDefault), desk: deliveryAmount(CFG.deliveryDeskDefault) };
  var unavailableDelivery = { home: parseUnavailable(CFG.deliveryUnavailable), desk: parseUnavailable(CFG.deliveryDeskUnavailable) };
  function deliveryMethod() {
    var selected = $('SaDeliveryMethod') || form.querySelector('input[name="Sa-Delivery-Method"]:checked');
    return selected && selected.value === 'desk' ? 'desk' : 'home';
  }
  function wilayaCode() {
    if (!wilayaEl || !wilayaEl.value || wilayaEl.selectedIndex < 0) return '';
    var match = asciiDigits(wilayaEl.options[wilayaEl.selectedIndex].textContent).match(/^\s*(\d+)/);
    return match ? String(Number(match[1])) : '';
  }
  function configuredDeliveryQuote(method) {
    var code = wilayaCode(), name = deliveryKey(wilayaEl ? wilayaEl.value : '');
    if (unavailableDelivery[method].indexOf(code) !== -1 || unavailableDelivery[method].indexOf(name) !== -1) {
      return { fee: null, free: false, available: false };
    }
    if (currentOffer && currentOffer.getAttribute('data-free-delivery') === 'true') return { fee: 0, free: true, available: true };
    if (!name) return { fee: null, free: false, available: true };
    var rates = deliveryRates[method], fee = defaultDelivery[method];
    if (Object.prototype.hasOwnProperty.call(rates, code)) fee = rates[code];
    else if (Object.prototype.hasOwnProperty.call(rates, name)) fee = rates[name];
    return { fee: fee, free: fee === 0, available: true };
  }
  function matchingPendingOrder() {
    if (isCurrentActiveOrder()) return activeOrder;
    // The initial price render runs before queue initialization. Once ready,
    // exact manual re-entry must display the saved quote before the next click.
    if (!memoryOrders) return null;
    var fingerprint = currentOrderFingerprint();
    return getQueue().filter(function (record) {
      return reusable(record) && !hasReceipt(record) && orderFingerprint(record.payload) === fingerprint;
    })[0] || confirmedRecordFor(fingerprint);
  }
  function deliveryQuote() {
    var pending = matchingPendingOrder();
    if (pending) {
      var capturedFee = deliveryAmount(pending.payload['Sa-Delivery-Fee']);
      return { fee: capturedFee, free: capturedFee === 0, available: true };
    }
    return configuredDeliveryQuote(deliveryMethod());
  }
  function renderDeliveryMethods() {
    var fixedMethod = $('SaDeliveryMethod');
    if (fixedMethod) {
      // New orders are home-only. Preserve the exact method of an unchanged
      // restored request so its retry cannot turn into a second order.
      if (fixedMethod.value === 'desk' && !restoringOrder && !matchingPendingOrder()) fixedMethod.value = 'home';
      if ($('codDeliveryLabel')) $('codDeliveryLabel').textContent = fixedMethod.value === 'desk' ? 'المكتب (طلب سابق)' : 'التوصيل للمنزل';
      return;
    }
    var pending = matchingPendingOrder();
    if (deliveryMethod() === 'desk' && !configuredDeliveryQuote('desk').available && !pending && !restoringOrder && $('codDeliveryHome')) {
      $('codDeliveryHome').checked = true;
    }
    ['home', 'desk'].forEach(function (method) {
      var radio = $(method === 'home' ? 'codDeliveryHome' : 'codDeliveryDesk');
      var price = $(method === 'home' ? 'codHomeDeliveryPrice' : 'codDeskDeliveryPrice');
      var quote = pending && deliveryMethod() === method ? deliveryQuote() : configuredDeliveryQuote(method);
      if (radio && !formSubmitted) radio.disabled = !quote.available;
      if (price) {
        price.textContent = !quote.available ? 'غير متاح' : quote.fee === null ? '' : quote.free ? 'مجاني' : fmt(quote.fee);
        price.hidden = !price.textContent;
        price.classList.toggle('is-free', quote.free);
      }
    });
  }
  function showDeliveryQuote(subtotal, fee) {
    // The product page shows the merchandise price. The saved receipt retains
    // the full quote so the thank-you page can show the fee and total correctly.
    if (CFG.deliveryOnThankYou === true) {
      var productSticky = document.querySelector('.sticky-price');
      if (productSticky) productSticky.textContent = fmt(subtotal);
      return;
    }
    var known = fee !== null;
    var delivery = $('codDeliveryFee');
    if (delivery) {
      delivery.textContent = known ? (fee === 0 ? 'مجاني' : fmt(fee))
        : wilayaEl && wilayaEl.value ? 'غير متاح حالياً' : 'اختر الولاية';
      delivery.classList.toggle('is-free', known && fee === 0);
    }
    if ($('codGrandTotalRow')) $('codGrandTotalRow').hidden = !known;
    if ($('codGrandTotal')) $('codGrandTotal').textContent = known ? fmt(subtotal + fee) : '';
    var sticky = document.querySelector('.sticky-price');
    if (sticky) sticky.textContent = fmt(known ? subtotal + fee : subtotal);
  }
  function setHiddenValue(id, value) { if ($(id)) $(id).value = value; }

  function renderPrices() {
    renderDeliveryMethods();
    var total = productTotal();
    var quote = deliveryQuote();
    $('SaUnitPrice').value = unitPrice;
    $('SaPrice').value = unitPrice;
    $('SaTotal').value = total;
    // Preserve the existing Sa-Total meaning for existing spreadsheet formulas.
    setHiddenValue('SaSubtotal', total);
    setHiddenValue('SaDeliveryFee', quote.fee === null ? '' : quote.fee);
    setHiddenValue('SaGrandTotal', quote.fee === null ? '' : total + quote.fee);
    setHiddenValue('SaFreeDelivery', String(quote.free));
    setHiddenValue('SaWilayaCode', wilayaCode());
    setHiddenValue('SaOfferId', currentOffer ? currentOffer.getAttribute('data-offer-id') || '' : '');

    document.querySelectorAll('[data-cod-price]').forEach(function (el) { el.textContent = fmt(unitPrice); });
    var save = comparePrice > unitPrice ? comparePrice - unitPrice : 0;
    document.querySelectorAll('[data-cod-old-price]').forEach(function (el) {
      el.hidden = !save; el.textContent = fmt(comparePrice);
    });
    document.querySelectorAll('[data-cod-save]').forEach(function (el) {
      el.hidden = !save; el.textContent = 'وفّر ' + fmt(save);
    });
    // Offer prices follow the selected variant's price
    form.querySelectorAll('input[name="Sa-Offer"]').forEach(function (r) {
      var row = r.closest('.offer-row');
      var t = offerTotal(r);
      var full = unitPrice * (parseFloat(r.getAttribute('data-qty')) || 1);
      var p = row.querySelector('[data-offer-price]');
      var o = row.querySelector('[data-offer-old]');
      if (p) p.textContent = fmt(t);
      if (o) { o.hidden = !(full > t); o.textContent = fmt(full); }
      row.classList.toggle('selected', r.checked);
    });
    showDeliveryQuote(total, quote.fee);
    if ($('codOrderQuantity')) $('codOrderQuantity').textContent = currentQty === 1 ? 'قطعة واحدة' : currentQty === 2 ? 'قطعتان' : currentQty + ' قطع';
    if ($('codOrderSubtotal')) $('codOrderSubtotal').textContent = fmt(total);
    updateSubmitState();
  }

  /*********** Quantity: offers when enabled, otherwise the − / + stepper ***********/
  function setQty(n) {
    currentQty = Math.max(1, Math.min(20, n));
    if ($('qtyVal')) $('qtyVal').textContent = currentQty;
    $('hiddenQty').value = currentQty;
    $('hiddenOffer').value = currentQty;
    renderPrices();
  }
  document.querySelectorAll('[data-qty-action]').forEach(function (b) {
    b.addEventListener('click', function () {
      setQty(currentQty + (b.getAttribute('data-qty-action') === 'inc' ? 1 : -1));
    });
  });
  function applyOffer() {
    currentOffer = form.querySelector('input[name="Sa-Offer"]:checked');
    if (currentOffer && currentOffer.getAttribute('data-restored-offer') !== 'true') clearRestoredOffer();
    if (currentOffer) setQty(parseInt(currentOffer.getAttribute('data-qty'), 10) || 1);
    else renderPrices();
  }
  form.querySelectorAll('input[name="Sa-Offer"]').forEach(function (r) {
    r.addEventListener('change', applyOffer);
  });

  /*********** Gallery (native scroll-snap swipe + thumbs + arrows) ***********/
  var slider = $('codSlider');
  var slides = slider ? slider.querySelectorAll('.cod-slide') : [];
  var activeSlide = 0;
  function goToSlide(i) {
    if (!slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    // offsetLeft works in both LTR and RTL; scrollLeft sign differs in RTL, so
    // scroll the slide into view horizontally only (never jumps the page).
    var target = slides[i];
    var sRect = slider.getBoundingClientRect();
    var tRect = target.getBoundingClientRect();
    slider.scrollBy({ left: tRect.left - sRect.left, behavior: 'smooth' });
  }
  function markSlide(i) {
    activeSlide = i;
    var count = $('codCount');
    if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    document.querySelectorAll('.cod-thumb').forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
  }
  if (slider && slides.length > 1) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) markSlide(Number(en.target.getAttribute('data-index')) || 0);
        });
      }, { root: slider, threshold: 0.6 });
      slides.forEach(function (s) { io.observe(s); });
    }
    document.querySelectorAll('.cod-thumb').forEach(function (t) {
      t.addEventListener('click', function () { goToSlide(Number(t.getAttribute('data-index')) || 0); });
    });
    document.querySelectorAll('[data-cod-nav]').forEach(function (b) {
      b.addEventListener('click', function () { goToSlide(activeSlide + Number(b.getAttribute('data-cod-nav'))); });
    });
    // Pause any playing video when it is swiped away
    slider.addEventListener('scroll', function () {
      slider.querySelectorAll('video').forEach(function (v) { if (!v.paused) v.pause(); });
    }, { passive: true });
  }
  function goToMedia(mediaId) {
    if (!mediaId || !slider) return;
    var s = slider.querySelector('.cod-slide[data-media-id="' + mediaId + '"]');
    if (s) goToSlide(Number(s.getAttribute('data-index')) || 0);
  }

  /*********** Variants ***********/
  var variants = [];
  try { variants = JSON.parse(($('codVariants') || {}).textContent || '[]'); } catch (e) {}
  function updateSubmitState() {
    var soldOut = variants.length ? !currentVariant || !currentVariant.available : !initiallyAvailable;
    // Stock checks protect new requests. A saved Submitted snapshot may already
    // have reserved the last piece, so its exact retry must still be confirmed.
    var knownOrder = matchingPendingOrder();
    var unavailable = soldOut && !knownOrder;
    var confirmed = knownOrder && hasReceipt(knownOrder);
    btn.disabled = unavailable || formSubmitted || form.dataset.codReady !== 'true';
    btn.classList.toggle('is-soldout', unavailable);
    if (!formSubmitted) {
      btn.innerHTML = confirmed ? '<span>عرض طلبك</span>' : knownOrder ? '<span>التحقق من طلبك</span>'
        : unavailable ? '<span class="btn-text"><span>' + (!variants.length ? 'هذا المنتج غير متوفر حالياً'
          : currentVariant ? 'نفد هذا الخيار — اختر خياراً آخر' : 'هذا الاختيار غير موجود — اختر خياراً آخر') + '</span></span>' : btnHTML;
    }
    var availability = $('variantAvailability');
    if (availability) {
      availability.hidden = !unavailable;
      availability.textContent = unavailable ? (variants.length ? 'هذا الاختيار غير متوفر حالياً. اختر لوناً أو مقاساً آخر.' : 'هذا المنتج غير متوفر حالياً.') : '';
    }
  }
  function selectedOptions() {
    var out = [];
    form.querySelectorAll('input[type=radio][data-option-index]:checked').forEach(function (r) {
      out[Number(r.getAttribute('data-option-index'))] = r.value;
    });
    return out;
  }
  function updateVariant(fromUser) {
    if (!variants.length) return;
    if (fromUser && currentOffer && currentOffer.getAttribute('data-restored-offer') === 'true') {
      clearRestoredOffer(); currentOffer = null; currentQty = 1;
      $('hiddenQty').value = '1'; $('hiddenOffer').value = '1';
    }
    var opts = selectedOptions();
    var v = null;
    for (var i = 0; i < variants.length; i++) {
      var ok = true;
      for (var k = 0; k < opts.length; k++) { if (opts[k] != null && variants[i].options[k] !== opts[k]) { ok = false; break; } }
      if (ok) { v = variants[i]; break; }
    }
    opts.forEach(function (val, k) {
      var lbl = form.querySelector('[data-option-label="' + k + '"]');
      if (lbl) lbl.textContent = val;
    });
    currentVariant = v;
    $('SaVariant').value = v ? v.title : opts.join(' / ');
    $('SaVariantId').value = v ? v.id : '';
    if (v) { unitPrice = v.price; comparePrice = v.compare; }
    if (!fromUser && currentOffer && currentOffer.getAttribute('data-restored-offer') === 'true') {
      unitPrice = Number(currentOffer.getAttribute('data-original-unit'));
    }
    // Mark values incompatible with the selected options, but keep them
    // selectable so customers can reach combinations requiring two changes.
    form.querySelectorAll('input[type=radio][data-option-index]').forEach(function (r) {
      var index = Number(r.getAttribute('data-option-index'));
      var available = variants.some(function (candidate) {
        return candidate.available && candidate.options[index] === r.value && opts.every(function (value, k) {
          return k === index || value == null || candidate.options[k] === value;
        });
      });
      var label = r.closest('label');
      if (label) label.classList.toggle('is-soldout', !available);
      r.setAttribute('aria-label', r.value + (available ? '' : ' — غير متوفر مع الاختيارات الحالية'));
    });
    renderPrices();
    if (fromUser && v && v.media) goToMedia(v.media);
  }
  if (variants.length) {
    var first = variants.filter(function (v) { return String(v.id) === String($('SaVariantId').value); })[0];
    if (first) { comparePrice = first.compare; currentVariant = first; }
    form.querySelectorAll('input[type=radio][data-option-index]').forEach(function (r) {
      r.addEventListener('change', function () { updateVariant(true); });
    });
    // Grey out option values that have no available variant at all
    form.querySelectorAll('input[type=radio][data-option-index]').forEach(function (r) {
      var k = Number(r.getAttribute('data-option-index'));
      var any = variants.some(function (v) { return v.available && v.options[k] === r.value; });
      if (!any) r.closest('label').classList.add('is-soldout');
    });
    updateVariant(false);
  } else {
    var oldEl = document.querySelector('[data-cod-old-price]');
    if (oldEl && !oldEl.hidden) comparePrice = parseFloat(oldEl.textContent.replace(/[^\d]/g, '')) || 0;
  }
  applyOffer();
  if (wilayaEl) wilayaEl.addEventListener('change', function () {
    wilayaEl.classList.toggle('is-invalid', !wilayaEl.value);
    renderPrices();
  });

  /*********** Phone — Algerian validation ***********/
  function extractDigits(str) {
    // Arabic-Indic / Persian digits → ASCII (common on Arabic keyboards)
    var d = String(str || '').replace(/[٠-٩]/g, function (c) { return c.charCodeAt(0) - 0x660; })
      .replace(/[۰-۹]/g, function (c) { return c.charCodeAt(0) - 0x6F0; })
      .replace(/\D/g, '');
    if (d.indexOf('00213') === 0) d = d.substring(5);
    else if (d.indexOf('213') === 0 && d.length >= 11) d = d.substring(3);
    if (d.length === 9 && /^[567]/.test(d)) d = '0' + d;
    return d;
  }
  function isValidAlgerianPhone(d) { return /^0[567]\d{8}$/.test(d); }
  function showPhoneMsg(text, ok) {
    if (!phoneMsg) return;
    phoneMsg.textContent = text;
    phoneMsg.classList.toggle('is-show', !!text);
    phoneMsg.classList.toggle('is-ok', !!ok);
  }
  function updatePhoneUI(strict) {
    var digits = extractDigits(phoneInput.value);
    $('SaPhoneDigits').value = digits;
    phoneInput.classList.remove('is-valid', 'is-invalid');
    phoneInput.removeAttribute('aria-invalid');
    if (!digits.length) { showPhoneMsg(strict ? '⚠️ أدخل رقم هاتفك ليتصل بك فريقنا' : ''); if (strict) { phoneInput.classList.add('is-invalid'); phoneInput.setAttribute('aria-invalid', 'true'); } return; }
    if (isValidAlgerianPhone(digits)) {
      phoneInput.classList.add('is-valid');
      showPhoneMsg('✓ رقم صحيح', true);
    } else if (digits.length < 10 && !strict) {
      showPhoneMsg('');
    } else {
      phoneInput.classList.add('is-invalid');
      phoneInput.setAttribute('aria-invalid', 'true');
      showPhoneMsg(digits.length < 10 ? '⚠️ الرقم ناقص — يجب أن يكون 10 أرقام' : '⚠️ رقم غير صحيح — يبدأ بـ 05 أو 06 أو 07 ويتكوّن من 10 أرقام');
    }
  }
  function hasPhoneForSending() {
    var digits = extractDigits(phoneInput.value);
    $('SaPhoneDigits').value = digits;
    return isValidAlgerianPhone(digits);
  }
  phoneInput.addEventListener('input', function () { updatePhoneUI(false); });
  phoneInput.addEventListener('blur', function () { if (phoneInput.value.trim()) updatePhoneUI(true); });

  /*********** IDs ***********/
  function safeUUID() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'id_' + Math.random().toString(36).slice(2) + '_' + Date.now().toString(36);
  }
  var SESSION_ID = (function () {
    try {
      var sid = sessionStorage.getItem('sa_session_id_v1');
      if (!sid) { sid = safeUUID(); sessionStorage.setItem('sa_session_id_v1', sid); }
      return sid;
    } catch (e) { return safeUUID(); }
  })();
  $('saSessionId').value = SESSION_ID;

  /*********** Date + page URL + GCLID/WBRAID/GBRAID (offline conversions) ***********/
  function stampDateTime() {
    var p = function (n) { return String(n).padStart(2, '0'); };
    var now = new Date();
    $('datetime').value = now.getFullYear() + '-' + p(now.getMonth() + 1) + '-' + p(now.getDate()) + ' ' + p(now.getHours()) + ':' + p(now.getMinutes()) + ':' + p(now.getSeconds());
  }
  function adClickCookie() {
    // gtag's conversion linker keeps the ad click in _gcl_aw / _gcl_gb as GCL.<time>.<id>.
    var match = document.cookie.match(/(?:^|;\s*)_gcl_(?:aw|gb)=([^;]+)/);
    var parts = match ? decodeURIComponent(match[1]).split('.') : [];
    return parts.length >= 3 && /^[A-Za-z0-9_-]{8,300}$/.test(parts.slice(2).join('.')) ? parts.slice(2).join('.') : '';
  }
  (function initDateTimeAndSource() {
    stampDateTime();
    $('campaignUrl').value = window.location.href;
    var params = new URLSearchParams(window.location.search || '');
    var gclid = params.get('gclid') || params.get('gclid_aw') || params.get('gcl_aw') || '';
    if (!gclid) gclid = params.get('wbraid') || params.get('gbraid') || '';
    if (!gclid) {
      // The ad may have opened the home page or another product first; the
      // layout keeps that click for 90 days so the offline conversion still matches.
      var landed = null;
      try { landed = JSON.parse(localStorage.getItem('sa_click_ids_v1') || 'null'); } catch (e) {}
      if (landed && typeof landed === 'object' && Date.now() - Number(landed.at) < 90 * 86400000) {
        gclid = landed.gclid || landed.wbraid || landed.gbraid || '';
        if (gclid && typeof landed.url === 'string') $('campaignUrl').value = landed.url;
      }
    }
    if (!gclid) try { gclid = adClickCookie(); } catch (e) {}
    $('gclid').value = gclid;
  })();

  /*********** Behaviour metrics (sent to the sheet only) ***********/
  var pageLoadTime = Date.now();
  var lastInteraction = Date.now();
  var mouseMoveCount = 0, mouseTotalDistance = 0, lastMouseX = null, lastMouseY = null;
  var scrollCount = 0, scrollTotalDistance = 0, scrollMaxDepth = 0;
  var lastScrollY = window.scrollY || 0, lastScrollTime = Date.now(), scrollLongestPause = 0;
  var focusCount = 1;

  var ua = (navigator.userAgent || '').toLowerCase();
  var viewportW = window.innerWidth || document.documentElement.clientWidth;
  var viewportH = window.innerHeight || document.documentElement.clientHeight;
  var deviceType = (/mobile|android|iphone|ipod/.test(ua) || viewportW <= 768) ? 'mobile'
    : ((/ipad|tablet/.test(ua) || viewportW <= 1024) ? 'tablet' : 'desktop');
  var networkType = (navigator.connection && navigator.connection.effectiveType) || '';

  ['input', 'change', 'click', 'touchstart'].forEach(function (evt) {
    document.addEventListener(evt, function () { lastInteraction = Date.now(); }, { capture: true, passive: true });
  });
  document.addEventListener('mousemove', function (e) {
    mouseMoveCount++;
    if (lastMouseX !== null) mouseTotalDistance += Math.sqrt(Math.pow(e.clientX - lastMouseX, 2) + Math.pow(e.clientY - lastMouseY, 2));
    lastMouseX = e.clientX; lastMouseY = e.clientY;
    lastInteraction = Date.now();
  }, { passive: true });
  window.addEventListener('scroll', function () {
    scrollCount++;
    lastInteraction = Date.now();
    var y = window.scrollY || 0;
    var max = document.documentElement.scrollHeight - viewportH;
    if (max > 0 && y / max > scrollMaxDepth) scrollMaxDepth = y / max;
    var now = Date.now();
    if (now - lastScrollTime > scrollLongestPause) scrollLongestPause = now - lastScrollTime;
    lastScrollTime = now;
    scrollTotalDistance += Math.abs(y - lastScrollY);
    lastScrollY = y;
  }, { passive: true });

  function getBehaviorMetrics() {
    return {
      'Sa-Time-Stay': String(Math.round((Date.now() - pageLoadTime) / 1000)),
      'Sa-Mouse-Move-Count': String(mouseMoveCount),
      'Sa-Mouse-Total-Distance': String(Math.round(mouseTotalDistance)),
      'Sa-Scroll-Count': String(scrollCount),
      'Sa-Scroll-Total-Distance': String(scrollTotalDistance),
      'Sa-Scroll-Max-Depth': scrollMaxDepth.toFixed(2),
      'Sa-Scroll-Longest-Pause': String(scrollLongestPause),
      'Sa-Scroll-Avg-Speed': String(scrollCount ? Math.round(scrollTotalDistance / scrollCount) : 0),
      'Sa-Device-Type': deviceType,
      'Sa-Viewport-W': String(viewportW),
      'Sa-Viewport-H': String(viewportH),
      'Sa-Screen-W': String((window.screen && screen.width) || viewportW),
      'Sa-Screen-H': String((window.screen && screen.height) || viewportH),
      'Sa-DPR': String(window.devicePixelRatio || 1),
      'Sa-Browser-Lang': navigator.language || '',
      'Sa-User-Agent': navigator.userAgent || '',
      'Sa-Network-Type': networkType,
      'Sa-Focus-Count': String(focusCount)
    };
  }

  /*********** FormData ***********/
  var botTrapHit = false;
  function buildFD(stage) {
    renderPrices();
    stampDateTime(); // the time of this snapshot, not of the page load
    var fd = new FormData(form);
    fd.set('Sa-Lead-Stage', stage);
    $('leadStage').value = stage;
    var eventId = safeUUID();
    fd.set('Sa-Session-Id', SESSION_ID);
    fd.set('Sa-Event-Id', eventId);
    $('saEventId').value = eventId;
    // Previewing an unpublished theme: the order site reads THIS theme's offer list, not the live one's.
    try { if (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main' && /^\d{1,20}$/.test(String(Shopify.theme.id))) fd.set('Sa-Preview-Theme', String(Shopify.theme.id)); } catch (e) {}
    fd.set('Sa-Phone-Digits', extractDigits(phoneInput.value));
    fd.set('Quantity', String(currentQty));
    fd.set('Offer', String(currentQty));
    var metrics = getBehaviorMetrics();
    Object.keys(metrics).forEach(function (k) { fd.set(k, metrics[k]); });
    $('timeStay').value = metrics['Sa-Time-Stay'];
    fd.set('Sa-Client-ISOTime', new Date().toISOString());
    fd.delete('Sa-Bot-Trap');
    // A browser autofill can fill the hidden field too: send the order and let
    // the sheet flag it for the confirmation call instead of dropping it.
    if (botTrapHit) fd.set('Sa-Bot-Trap-Hit', '1');
    return fd;
  }
  /*********** Durable pending orders ***********/
  // One key per event prevents a successful order from erasing another order
  // for the same customer. Keep unacknowledged orders; never truncate the queue.
  // Confirmed orders of this tab. In-app browsers (Facebook, Instagram, TikTok)
  // often reload the product page on Back instead of restoring it: the same
  // details must then reopen the saved receipt, never post a second order.
  var CONFIRMED_KEY = 'sa_confirmed_orders_v1', CONFIRMED_TTL = 86400000;
  function confirmedInTab() {
    try {
      var map = JSON.parse(sessionStorage.getItem(CONFIRMED_KEY) || '{}');
      return map && typeof map === 'object' && !Array.isArray(map) ? map : {};
    } catch (e) { return {}; }
  }
  function rememberConfirmed(record) {
    var map = confirmedInTab(), now = Date.now();
    Object.keys(map).forEach(function (key) { if (!(now - Number(map[key] && map[key].at) < CONFIRMED_TTL)) delete map[key]; });
    map[orderFingerprint(record.payload)] = { at: now, record: { endpoint: record.endpoint, createdAt: record.createdAt,
      payload: record.payload, receipt: record.receipt || null } };
    Object.keys(map).sort(function (a, b) { return map[b].at - map[a].at; }).slice(10).forEach(function (key) { delete map[key]; });
    try { sessionStorage.setItem(CONFIRMED_KEY, JSON.stringify(map)); } catch (e) {}
  }
  function confirmedRecordFor(fingerprint) {
    var entry = confirmedInTab()[fingerprint];
    if (!entry || !(Date.now() - Number(entry.at) < CONFIRMED_TTL) || !validRecord(entry.record)) return null;
    confirmedOrders[entry.record.payload['Sa-Event-Id']] = true;
    return entry.record;
  }

  var QUEUE_PREFIX = 'sa_pending_order_v2:';
  var memoryOrders = Object.create(null);
  var confirmedOrders = Object.create(null);
  var inFlightOrders = Object.create(null);
  var REQUEST_TIMEOUT = 15000;
  var recoveryOrder = null;
  // Saved records keep the Google link they were sent to: when the store's link
  // changes between two visits, a pending order is still found and re-sent there.
  var SCRIPT_ENDPOINT = /^https:\/\/script\.google\.com\/macros\/s\/[A-Za-z0-9_-]+\/exec$/;
  function knownEndpoint(url) { return url === APPS_SCRIPT_URL || SCRIPT_ENDPOINT.test(String(url || '')); }
  // An unconfirmed order is reused for an identical tap only within 20 hours; after
  // that a new identical order is a new order (the old one stays recoverable from
  // the banner for 7 days, then it is cleared).
  var REUSE_WINDOW = 20 * 3600000, KEEP_PENDING = 7 * 86400000;
  function reusable(record) { return Date.now() - Number(record.createdAt) < REUSE_WINDOW; }
  function validRecord(record) {
    return record && knownEndpoint(record.endpoint) && record.payload &&
      record.payload['Sa-Lead-Stage'] === 'Submitted' &&
      /^[a-zA-Z0-9_-]{1,180}$/.test(record.payload['Sa-Event-Id'] || '');
  }
  function saveRecord(record) {
    var id = record.payload['Sa-Event-Id'];
    memoryOrders[id] = record;
    try { localStorage.setItem(QUEUE_PREFIX + id, JSON.stringify(record)); return true; }
    catch (e) { return false; }
  }
  function getQueue() {
    var records = Object.create(null);
    Object.keys(memoryOrders).forEach(function (id) { records[id] = memoryOrders[id]; });
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (!key || key.indexOf(QUEUE_PREFIX) !== 0) continue;
        try {
          var record = JSON.parse(localStorage.getItem(key));
          if (!validRecord(record)) continue;
          if (!(Date.now() - Number(record.createdAt) < KEEP_PENDING)) { localStorage.removeItem(key); i--; continue; }
          records[record.payload['Sa-Event-Id']] = record;
        } catch (e) {}
      }
    } catch (e) {}
    return Object.keys(records).map(function (id) { return records[id]; }).filter(validRecord);
  }
  function acknowledge(record) {
    var id = record.payload['Sa-Event-Id'];
    confirmedOrders[id] = true;
    delete memoryOrders[id];
    // Store a small receipt without customer details for other open tabs.
    try { localStorage.removeItem(QUEUE_PREFIX + id); } catch (e) {}
    try { localStorage.setItem('sa_order_receipt_v2:' + id, String(Date.now())); } catch (e) {}
    rememberConfirmed(record);
    // An older unconfirmed copy of exactly this order (kept past the 20-hour
    // reuse window) is retired too, so it can never be re-sent as a second order.
    var sameOrder = orderFingerprint(record.payload);
    getQueue().forEach(function (older) {
      var olderId = older.payload['Sa-Event-Id'];
      if (olderId === id || hasReceipt(older) || inFlightOrders[olderId] || orderFingerprint(older.payload) !== sameOrder) return;
      confirmedOrders[olderId] = true;
      delete memoryOrders[olderId];
      try { localStorage.removeItem(QUEUE_PREFIX + olderId); } catch (e) {}
      try { localStorage.setItem('sa_order_receipt_v2:' + olderId, String(Date.now())); } catch (e) {}
    });
    // Follow-up snapshots still waiting to be sent are now obsolete: they must
    // not reach the sheet later and send the call centre after this customer.
    var phone = extractDigits(record.payload['Sa-Phone-Digits'] || record.payload['Sa-Phone']);
    pendingLeads().forEach(function (lead) {
      if (inFlightLeads[lead.payload['Sa-Event-Id']]) return;
      if (lead.payload['Sa-Session-Id'] === record.payload['Sa-Session-Id'] ||
          extractDigits(lead.payload['Sa-Phone-Digits'] || lead.payload['Sa-Phone']) === phone) acknowledgeLead(lead);
    });
    updateRecovery();
  }
  function hasReceipt(record) {
    var id = record.payload['Sa-Event-Id'];
    if (confirmedOrders[id]) return true;
    try { return !!localStorage.getItem('sa_order_receipt_v2:' + id); }
    catch (e) { return false; }
  }
  function orderFingerprint(payload) {
    // Only business fields participate; timestamps and behaviour metrics vary
    // between clicks and must not create a new identity for the same retry.
    return JSON.stringify(['Sa-Name', 'Sa-Phone-Digits', 'Sa-Wilaya', 'Sa-Address',
      'Sa-Product-Name', 'Sa-Variant-Id', 'Sa-Offer', 'Quantity', 'Sa-Unit-Price', 'Sa-Total', 'Sa-Delivery-Method'
    ].map(function (key) {
      var value = String(payload[key] == null ? '' : payload[key]).trim();
      if (key === 'Sa-Phone-Digits') value = extractDigits(value || payload['Sa-Phone']);
      if (key === 'Sa-Delivery-Method' && !value) value = 'home';
      return value;
    }));
  }
  function currentOrderFingerprint() {
    return orderFingerprint({
      'Sa-Name': (form.elements['Sa-Name'] || {}).value,
      'Sa-Phone-Digits': extractDigits(phoneInput.value),
      'Sa-Wilaya': wilayaEl ? wilayaEl.value : '',
      'Sa-Address': (form.elements['Sa-Address'] || {}).value,
      'Sa-Product-Name': (form.elements['Sa-Product-Name'] || {}).value,
      'Sa-Variant-Id': $('SaVariantId').value,
      'Sa-Offer': currentOffer ? currentOffer.value : '',
      'Sa-Delivery-Method': deliveryMethod(),
      'Quantity': currentQty, 'Sa-Unit-Price': unitPrice, 'Sa-Total': productTotal()
    });
  }
  function isCurrentActiveOrder() {
    return activeOrder && orderFingerprint(activeOrder.payload) === currentOrderFingerprint();
  }
  form.addEventListener('input', function (event) {
    if (['Sa-Name', 'Sa-Phone', 'Sa-Address'].indexOf(event.target.name) !== -1) renderPrices();
  });
  form.querySelectorAll('input[name="Sa-Delivery-Method"]').forEach(function (radio) {
    radio.addEventListener('change', function () { clearFieldError(wilayaEl, 'wilayaMessage'); renderPrices(); });
  });
  function recordFor(fd) {
    var payload = {};
    fd.forEach(function (value, key) { payload[key] = String(value); });
    var fingerprint = orderFingerprint(payload);
    if (activeOrder && orderFingerprint(activeOrder.payload) === fingerprint) return activeOrder;
    var existing = getQueue().filter(function (record) {
      return reusable(record) && !hasReceipt(record) && orderFingerprint(record.payload) === fingerprint;
    })[0];
    if (existing) return existing;
    var confirmed = confirmedRecordFor(fingerprint);
    if (confirmed) return confirmed;
    return { endpoint: APPS_SCRIPT_URL, createdAt: Date.now(), payload: payload };
  }
  // Preserve old failed submissions when upgrading; malformed entries cannot
  // prevent fresh orders. No automatic replay without customer confirmation.
  (function migrateQueue() {
    try {
      var old = JSON.parse(localStorage.getItem('sa_failed_queue_v1') || '[]');
      if (!Array.isArray(old)) return;
      var allSaved = true;
      old.forEach(function (payload) {
        var record = { endpoint: APPS_SCRIPT_URL, createdAt: payload && payload.__queuedAt || Date.now(), payload: payload };
        if (!validRecord(record)) return;
        var clean = {};
        Object.keys(payload).forEach(function (key) { if (key.indexOf('__') !== 0) clean[key] = payload[key]; });
        record.payload = clean;
        if (!hasReceipt(record) && !saveRecord(record)) allSaved = false;
      });
      if (allSaved) localStorage.removeItem('sa_failed_queue_v1');
    } catch (e) {}
  })();

  function readAcknowledgement(response, record) {
    if (!response || !response.ok) throw new Error('http');
    return response.text().then(function (text) {
      var data;
      try { data = JSON.parse(text); } catch (e) { throw new Error('unconfirmed'); }
      if (data && data.result === 'error' && (!data.eventId || data.eventId === record.payload['Sa-Event-Id'])) {
        // The receiver answered and wrote nothing. 'busy' is worth one retry.
        var refused = new Error(data.code === 'busy' ? 'busy' : 'unconfirmed');
        refused.code = String(data.code || ''); refused.retryable = data.retryable === true;
        throw refused;
      }
      // This is the supplied Apps Script's contract, including errors returned
      // with HTTP 200. Never redirect on a Google error page or an empty reply.
      if (!data || data.result !== 'success' || data.success === false || data.error ||
          (data.eventId && data.eventId !== record.payload['Sa-Event-Id'])) throw new Error('unconfirmed');
      if (record.payload['Sa-Lead-Stage'] === 'Submitted' && data.eventId === record.payload['Sa-Event-Id']) {
        // Keep the server receipt separate from the immutable original request.
        // The token is passed to thank-you only through sessionStorage.
        record.receipt = {
          amendmentToken: typeof data.amendmentToken === 'string' ? data.amendmentToken : '',
          effectiveOrder: confirmedOrderSummary(data.effectiveOrder)
        };
      }
      return data;
    });
  }
  function postOrder(record) {
    var params = new URLSearchParams();
    Object.keys(record.payload).forEach(function (key) { params.append(key, record.payload[key]); });
    // Never aborted: a slow Apps Script still saves the order, and its late
    // answer must be able to confirm it (see lateConfirmation).
    return Promise.resolve().then(function () {
      return fetch(record.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(), keepalive: true });
    }).then(function (response) { return readAcknowledgement(response, record); });
  }
  function lateConfirmation(record) {
    // The answer came after the customer was told we could not confirm.
    updateRecovery();
    if (submissionConfirmed) return;
    $('formNetworkError').style.display = 'none';
    if ($('formNetworkHelp')) $('formNetworkHelp').hidden = true;
    if (formSubmitted) return; // another send is running and will answer by itself
    if (activeOrder === record && isCurrentActiveOrder()) {
      submissionConfirmed = formSubmitted = true;
      btn.disabled = true;
      btn.innerHTML = '<span>✅ تم إرسال طلبك</span>';
      redirectToThankYou(record);
      return;
    }
    // The details were edited after the error: the first order did arrive, so say
    // so (a second tap would only place it again) and offer its receipt.
    var box = $('codLateConfirmed');
    if (!box) {
      box = document.createElement('div');
      box.id = 'codLateConfirmed'; box.className = 'cod-recovery-status'; box.setAttribute('role', 'status');
      box.appendChild(document.createElement('span'));
      var view = document.createElement('button'); view.type = 'button'; view.textContent = 'عرض طلبك';
      box.appendChild(view);
      btn.parentNode.insertBefore(box, btn);
    }
    var savedPhone = extractDigits(record.payload['Sa-Phone-Digits'] || record.payload['Sa-Phone']);
    box.querySelector('span').textContent = savedPhone === extractDigits(phoneInput.value)
      ? '✅ وصلنا طلبك السابق — لا داعي لإعادة الطلب. سنتصل بك لتأكيده.'
      : '✅ وصلنا طلبك السابق بالرقم ' + savedPhone + '. إذا كان هذا الرقم خاطئاً، اضغط «أطلب الآن» لإرسال الطلب بالرقم الصحيح.';
    box.hidden = false;
    box.querySelector('button').onclick = function () {
      submissionConfirmed = formSubmitted = true;
      redirectToThankYou(record);
    };
  }
  // A failure of the order site itself (no answer, an error page, a broken reply, "could not save") — not a
  // refusal of this particular order: only then does the order take the second door.
  function hardFailure(error) {
    if (!error) return false;
    if (error.name === 'TypeError' || error.message === 'http' || error.message === 'busy') return true;
    return error.message === 'unconfirmed' && (!error.code || error.code === 'save_failed');
  }
  function backupAllowed(record) {
    return !!BACKUP_URL && record.endpoint !== BACKUP_URL && record.payload['Sa-Lead-Stage'] === 'Submitted' && navigator.onLine !== false;
  }
  function sendBackup(record) {
    var params = new URLSearchParams();
    Object.keys(record.payload).forEach(function (key) { params.append(key, record.payload[key]); });
    params.set('Sa-Backup-Door', '1');
    // no-cors, like the store's old theme: Google's answer cannot be read here, only that it was delivered.
    return Promise.resolve().then(function () {
      return fetch(BACKUP_URL, { method: 'POST', mode: 'no-cors', body: params, keepalive: true, credentials: 'omit' });
    }).then(function (response) { if (!response || (response.type !== 'opaque' && !response.ok)) throw new Error('backup'); });
  }
  function sendOrder(record) {
    var id = record.payload['Sa-Event-Id'];
    if (inFlightOrders[id]) return inFlightOrders[id];
    function transport() {
      if (hasReceipt(record)) return Promise.resolve();
      if (navigator.onLine === false) return Promise.reject(new Error('offline'));
      function attempt(n) {
        return postOrder(record).catch(function (error) {
          // 'busy' means the receiver wrote nothing; a short wait usually frees it.
          if (error.message !== 'busy' || n >= 3) throw error;
          return new Promise(function (resolve) { setTimeout(resolve, 1500 * n); }).then(function () { return attempt(n + 1); });
        });
      }
      var delivery = attempt(1).then(function () { acknowledge(record); });
      return new Promise(function (resolve, reject) {
        var settled = false, backupTried = false, timer, backupTimer;
        function settle(fn, value) { if (settled) return; settled = true; clearTimeout(timer); clearTimeout(backupTimer); fn(value); }
        timer = setTimeout(function () { settle(reject, new Error('timeout')); }, REQUEST_TIMEOUT);
        // The order site silent for 8 s: the second door (the order site may still answer later).
        backupTimer = setTimeout(function () { useBackup(null); }, BACKUP_AFTER);
        function useBackup(error) {
          if (settled || backupTried || !backupAllowed(record)) { if (error) settle(reject, error); return; }
          backupTried = true;
          sendBackup(record).then(function () {
            if (settled) return;
            record.viaBackup = true;
            acknowledge(record);
            settle(resolve);
          }, function () { if (error) settle(reject, error); });
        }
        delivery.then(function () {
          if (!settled) settle(resolve);
          else lateConfirmation(record);
        }, function (error) {
          if (settled) return;
          if (hardFailure(error)) useBackup(error); else settle(reject, error);
        });
      });
    }
    // Coordinate open tabs where Web Locks is supported. Server-side event-ID
    // deduplication is still required for timeouts and older browsers.
    var request = Promise.resolve().then(function () {
      if (!(navigator.locks && navigator.locks.request)) return transport();
      var entered = false;
      return navigator.locks.request('cod-order-' + id, { ifAvailable: true }, function (lock) {
        entered = true;
        if (!lock) throw new Error('in-progress');
        return transport();
      }).catch(function (error) {
        // Chrome refuses Web Locks when the site's storage is blocked; the
        // order must still be sent (the receiver deduplicates the event ID).
        if (entered) throw error;
        return transport();
      });
    });
    inFlightOrders[id] = request.then(function (result) { delete inFlightOrders[id]; return result; },
      function (error) { delete inFlightOrders[id]; throw error; });
    return inFlightOrders[id];
  }

  /*********** Durable incomplete leads (never submitted as orders) ***********/
  // Keep snapshots until the receiver confirms their exact event. A beacon's
  // true return value only means queued by the browser, not saved in the Sheet.
  // Safe replay requires the receiver's event-ID idempotency protection.
  var LEAD_QUEUE_PREFIX = 'sa_pending_lead_v1:';
  var memoryLeads = Object.create(null), confirmedLeads = Object.create(null);
  var inFlightLeads = Object.create(null);
  var leadFlushInProgress = false, leadRetryAfter = 0, leadFailureCount = 0;
  var leadWindowStarted = 0, leadRequestsInWindow = 0;
  function validLeadRecord(record) {
    return record && knownEndpoint(record.endpoint) && record.payload &&
      ['Draft', 'Attempted', 'Abandoned'].indexOf(record.payload['Sa-Lead-Stage']) !== -1 &&
      /^[a-zA-Z0-9_-]{8,100}$/.test(record.payload['Sa-Event-Id'] || '') &&
      isValidAlgerianPhone(extractDigits(record.payload['Sa-Phone-Digits'] || record.payload['Sa-Phone']));
  }
  function saveLeadRecord(record) {
    var id = record.payload['Sa-Event-Id'];
    memoryLeads[id] = record;
    try { localStorage.setItem(LEAD_QUEUE_PREFIX + id, JSON.stringify(record)); } catch (e) {}
  }
  function pendingLeads() {
    var records = Object.create(null);
    Object.keys(memoryLeads).forEach(function (id) { records[id] = memoryLeads[id]; });
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (!key || key.indexOf(LEAD_QUEUE_PREFIX) !== 0) continue;
        try {
          var record = JSON.parse(localStorage.getItem(key));
          if (validLeadRecord(record) && key === LEAD_QUEUE_PREFIX + record.payload['Sa-Event-Id']) {
            records[record.payload['Sa-Event-Id']] = record;
          }
        } catch (e) {}
      }
    } catch (e) {}
    return Object.keys(records).map(function (id) { return records[id]; }).filter(function (record) {
      return validLeadRecord(record) && !confirmedLeads[record.payload['Sa-Event-Id']];
    }).sort(function (a, b) { return (Number(a.createdAt) || 0) - (Number(b.createdAt) || 0); });
  }
  function acknowledgeLead(record) {
    var id = record.payload['Sa-Event-Id'];
    confirmedLeads[id] = true;
    delete memoryLeads[id];
    try { localStorage.removeItem(LEAD_QUEUE_PREFIX + id); } catch (e) {}
  }
  function sendLead(record) {
    var id = record.payload['Sa-Event-Id'];
    if (inFlightLeads[id]) return inFlightLeads[id];
    // Retry bookkeeping is separate from the immutable captured payload.
    record.attempts = Math.min(5, (Number(record.attempts) || 0) + 1);
    record.nextAttemptAt = Date.now() + Math.min(300000, 30000 * Math.pow(2, record.attempts - 1));
    saveLeadRecord(record);
    var request = new Promise(function (resolve, reject) {
      var settled = false;
      var timer = setTimeout(function () { settled = true; reject(new Error('timeout')); }, REQUEST_TIMEOUT);
      var params = new URLSearchParams();
      Object.keys(record.payload).forEach(function (key) { params.append(key, record.payload[key]); });
      var options = { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(), keepalive: true };
      Promise.resolve().then(function () {
        if (formSubmitted) throw new Error('order-in-progress');
        return fetch(record.endpoint, options);
      }).then(function (response) { return readAcknowledgement(response, record); })
        .then(function () {
          // A reply arriving after our timeout can still confirm this event.
          acknowledgeLead(record);
          if (!settled) { settled = true; clearTimeout(timer); resolve(); }
        }, function (error) {
          // A definite refusal will never succeed: stop resending this snapshot.
          if (error && error.code && error.retryable === false) {
            acknowledgeLead(record);
            if (!settled) { settled = true; clearTimeout(timer); resolve(); }
            return;
          }
          if (!settled) { settled = true; clearTimeout(timer); reject(error); }
        });
    });
    inFlightLeads[id] = request.then(function () { delete inFlightLeads[id]; },
      function (error) { delete inFlightLeads[id]; throw error; });
    return inFlightLeads[id];
  }
  function flushLeadQueue() {
    if (!APPS_SCRIPT_URL || typeof fetch !== 'function' || leadFlushInProgress || formSubmitted ||
        navigator.onLine === false || Date.now() < leadRetryAfter) return;
    if (Date.now() - leadWindowStarted >= 30000) { leadWindowStarted = Date.now(); leadRequestsInWindow = 0; }
    if (leadRequestsInWindow >= 3) return;
    leadFlushInProgress = true;
    function next() {
      if (formSubmitted || navigator.onLine === false || leadRequestsInWindow >= 3) return Promise.resolve();
      var now = Date.now();
      var record = pendingLeads().filter(function (item) {
        return !inFlightLeads[item.payload['Sa-Event-Id']] && !(Number(item.nextAttemptAt) > now);
      })[0];
      if (!record) return Promise.resolve();
      leadRequestsInWindow++;
      return sendLead(record).then(function () {
        leadFailureCount = 0;
        leadRetryAfter = 0;
        return next();
      }, function () {
        leadFailureCount = Math.min(5, leadFailureCount + 1);
        leadRetryAfter = Date.now() + Math.min(300000, 30000 * Math.pow(2, leadFailureCount - 1));
      });
    }
    next().then(function () { leadFlushInProgress = false; }, function () { leadFlushInProgress = false; });
  }
  function queueLeadSnapshot(fd) {
    var payload = {};
    fd.forEach(function (value, key) { payload[key] = String(value); });
    var record = { endpoint: APPS_SCRIPT_URL, createdAt: Date.now(), payload: payload, attempts: 0, nextAttemptAt: 0 };
    if (!validLeadRecord(record)) return;
    // The newest snapshot replaces this session's unsent older ones (the sheet
    // keeps one follow-up row per session anyway).
    pendingLeads().forEach(function (older) {
      if (older.payload['Sa-Session-Id'] === payload['Sa-Session-Id'] && !inFlightLeads[older.payload['Sa-Event-Id']]) acknowledgeLead(older);
    });
    saveLeadRecord(record);
    flushLeadQueue();
  }
  window.addEventListener('online', flushLeadQueue);
  setInterval(flushLeadQueue, 30000);

  function updateRecovery() {
    var product = (form.elements['Sa-Product-Name'] || {}).value;
    recoveryOrder = getQueue().filter(function (record) {
      return !hasReceipt(record) && record.payload['Sa-Product-Name'] === product &&
        !confirmedRecordFor(orderFingerprint(record.payload));
    }).sort(function (a, b) { return b.createdAt - a.createdAt; })[0] || null;
    if ($('formRecoveryStatus')) $('formRecoveryStatus').hidden = !recoveryOrder || formSubmitted;
    updateSubmitState();
  }
  function restorePendingOrder() {
    if (!recoveryOrder || formSubmitted) return;
    var payload = recoveryOrder.payload;
    var savedVariant = variants.filter(function (v) { return String(v.id) === String(payload['Sa-Variant-Id']); })[0];
    if (variants.length ? !savedVariant : String($('SaVariantId').value) !== String(payload['Sa-Variant-Id'])) {
      networkError('الخيار المحفوظ لم يعد متاحاً حالياً. اتصل بنا للتأكد من طلبك السابق قبل اختيار منتج آخر.');
      return;
    }
    restoringOrder = true;
    activeOrder = recoveryOrder;
    ['Sa-Name', 'Sa-Phone', 'Sa-Wilaya', 'Sa-Address'].forEach(function (key) {
      if (form.elements[key]) form.elements[key].value = payload[key] || '';
    });
    if ($('SaDeliveryMethod')) $('SaDeliveryMethod').value = payload['Sa-Delivery-Method'] === 'desk' ? 'desk' : 'home';
    form.querySelectorAll('input[type="radio"][name="Sa-Delivery-Method"]').forEach(function (radio) {
      radio.checked = radio.value === (payload['Sa-Delivery-Method'] || 'home');
    });
    if (savedVariant) {
      form.querySelectorAll('input[type=radio][data-option-index]').forEach(function (r) {
        r.checked = savedVariant.options[Number(r.getAttribute('data-option-index'))] === r.value;
      });
      updateVariant(false);
    }
    var savedOffer = Array.from(form.querySelectorAll('input[name="Sa-Offer"]')).filter(function (r) { return r.value === payload['Sa-Offer']; })[0];
    // Upgrading the theme moves offer controls to thank-you. A previously
    // attempted bundle must still retry its exact original payload and price.
    if (!savedOffer && (payload['Sa-Offer'] || !form.querySelector('input[name="Sa-Offer"]'))) savedOffer = restoreLegacyOffer(payload);
    if (savedOffer) { savedOffer.checked = true; applyOffer(); }
    else if (!currentOffer) setQty(parseInt(payload.Quantity, 10) || 1);
    updatePhoneUI(false);
    restoringOrder = false;
    renderPrices();
    clearFieldError(form.elements['Sa-Name'], 'nameMessage');
    clearFieldError(wilayaEl, 'wilayaMessage');
    if ($('formRecoveryStatus')) $('formRecoveryStatus').hidden = true;
    scrollToForm();
  }
  function clearRestoredOffer() {
    var row = $('codRestoredOffer'), note = $('codRestoredOfferNotice');
    if (row) row.remove();
    if (note) note.remove();
  }
  function restoreLegacyOffer(payload) {
    var quantity = deliveryAmount(payload.Quantity), subtotal = deliveryAmount(payload['Sa-Total']),
      price = deliveryAmount(payload['Sa-Unit-Price']);
    if (!quantity || quantity > 20 || subtotal === null || price === null) return null;
    clearRestoredOffer();
    var row = document.createElement('div'); row.id = 'codRestoredOffer'; row.className = 'offer-row'; row.hidden = true; row.style.display = 'none';
    var radio = document.createElement('input'); radio.type = 'radio'; radio.name = 'Sa-Offer'; radio.value = payload['Sa-Offer'] || ''; radio.tabIndex = -1;
    radio.setAttribute('data-restored-offer', 'true'); radio.setAttribute('data-original-unit', String(price));
    radio.setAttribute('data-qty', String(quantity)); radio.setAttribute('data-paid', String(quantity));
    radio.setAttribute('data-price', String(subtotal)); radio.setAttribute('data-offer-id', payload['Sa-Offer-Id'] || '');
    radio.setAttribute('data-free-delivery', String(deliveryAmount(payload['Sa-Delivery-Fee']) === 0));
    row.appendChild(radio); form.appendChild(row);
    var note = document.createElement('p'); note.id = 'codRestoredOfferNotice'; note.className = 'cod-recovery-status';
    note.textContent = 'تم استرجاع طلبك السابق (' + quantity + ' قطع).';
    var summary = form.querySelector('.cod-order-summary'); form.insertBefore(note, summary || btn);
    unitPrice = price;
    return radio;
  }
  if ($('restorePendingOrder')) $('restorePendingOrder').addEventListener('click', restorePendingOrder);
  window.addEventListener('storage', function (event) {
    if (!event.key || event.key.indexOf('sa_pending_order_v2:') === 0 || event.key.indexOf('sa_order_receipt_v2:') === 0) updateRecovery();
  });

  /*********** Thank-you redirect ***********/
  function confirmedOrderSummary(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
    var qty = deliveryAmount(value.qty), subtotal = deliveryAmount(value.subtotal),
      fee = deliveryAmount(value.deliveryFee), grand = deliveryAmount(value.grandTotal);
    if (qty === null || qty < 1 || qty > 20 || subtotal === null || fee === null || grand === null ||
        subtotal + fee !== grand || !Number.isSafeInteger(grand)) return null;
    return { qty: qty, total: subtotal, subtotal: subtotal, deliveryFee: fee, grandTotal: grand,
      freeDelivery: fee === 0, deliveryMethod: value.deliveryMethod === 'desk' ? 'desk' : 'home',
      offer: typeof value.offer === 'string' ? value.offer : '',
      variant: typeof value.variant === 'string' ? value.variant : '' };
  }
  function redirectToThankYou(record) {
    // Customer details go through sessionStorage, NOT the URL: a name/phone in
    // the query string ends up in analytics + ad pixels (Meta flags that as
    // personal data), in the browser history and in shared links.
    var payload = record.payload;
    var order = {
      name: payload['Sa-Name'] || '',
      phone: payload['Sa-Phone-Digits'],
      wilaya: payload['Sa-Wilaya'] || '',
      product: CFG.productTitle || '',
      productId: payload['Sa-Product-Id'] || '',
      productHandle: payload['Sa-Product-Handle'] || '',
      postPurchaseEnabled: CFG.postPurchaseEnabled === true && payload['Sa-Post-Purchase-Enabled'] === 'true',
      endpoint: record.endpoint,
      amendmentToken: record.receipt ? record.receipt.amendmentToken : '',
      variant: payload['Sa-Variant'] === 'Default Title' ? '' : payload['Sa-Variant'] || '',
      offer: payload['Sa-Offer'] || '',
      qty: payload.Quantity,
      total: payload['Sa-Total'],
      subtotal: payload['Sa-Subtotal'] || payload['Sa-Total'],
      deliveryFee: deliveryAmount(payload['Sa-Delivery-Fee']),
      grandTotal: deliveryAmount(payload['Sa-Grand-Total']),
      freeDelivery: payload['Sa-Free-Delivery'] === 'true',
      deliveryMethod: payload['Sa-Delivery-Method'] || '',
      eventId: payload['Sa-Event-Id']
    };
    if (record.receipt && record.receipt.effectiveOrder) {
      Object.keys(record.receipt.effectiveOrder).forEach(function (key) { order[key] = record.receipt.effectiveOrder[key]; });
    }
    // Returning to this form must retain an upgrade already acknowledged on
    // thank-you instead of replacing it with the immutable one-piece request.
    try {
      var previous = JSON.parse(sessionStorage.getItem('cod_last_order') || 'null');
      var upgraded = previous && previous.eventId === order.eventId && String(previous.revision) === '1'
        ? confirmedOrderSummary(previous) : null;
      if (upgraded) {
        Object.keys(upgraded).forEach(function (key) { order[key] = upgraded[key]; });
        order.revision = '1';
      }
    } catch (e) {}
    try { sessionStorage.setItem('cod_last_order', JSON.stringify(order)); } catch (e) {}
    var destination = new URL(THANKYOU_URL, window.location.href);
    destination.searchParams.set('q', order.qty);
    destination.searchParams.set('t', order.total);
    destination.searchParams.set('e', order.eventId);
    // Numeric amounts only; customer name, phone and address stay off the URL.
    if (order.deliveryFee !== null && order.grandTotal !== null) {
      destination.searchParams.set('d', String(order.deliveryFee));
      destination.searchParams.set('g', String(order.grandTotal));
    } else {
      destination.searchParams.delete('d');
      destination.searchParams.delete('g');
    }
    if (order.deliveryMethod) destination.searchParams.set('m', order.deliveryMethod);
    else destination.searchParams.delete('m');
    window.location.href = destination.href;
  }

  var lastAbandonedHash = '', lastDraftHash = '', lastAttemptHash = '';
  function draftHash() {
    return JSON.stringify([extractDigits(phoneInput.value), (form.elements['Sa-Name'].value || '').trim(),
      wilayaEl ? wilayaEl.value : '', (form.elements['Sa-Address'].value || '').trim(),
      currentQty, $('SaVariantId').value, currentOffer ? currentOffer.value : '', unitPrice, productTotal(), deliveryMethod(), deliveryQuote().fee]);
  }
  function orderAlreadyPlaced() {
    // Also true after a reload that lost the in-memory order: the same details
    // were already confirmed in this tab, so no follow-up draft is needed.
    return isCurrentActiveOrder() || !!confirmedRecordFor(currentOrderFingerprint());
  }
  function sendAttemptedIfNeeded() {
    if (document.visibilityState === 'hidden' || formSubmitted || orderAlreadyPlaced() || !hasPhoneForSending()) return;
    var h = draftHash();
    if (h === lastAttemptHash) return;
    lastAttemptHash = h;
    queueLeadSnapshot(buildFD('Attempted'));
  }
  function sendAbandonedLead() {
    if (formSubmitted || orderAlreadyPlaced() || !hasPhoneForSending()) return;
    var h = draftHash();
    if (h === lastAbandonedHash) return;
    lastAbandonedHash = h;
    queueLeadSnapshot(buildFD('Abandoned'));
  }
  function sendDraftSnapshot() {
    if (document.visibilityState === 'hidden' || formSubmitted || orderAlreadyPlaced() || !hasPhoneForSending()) return;
    var h = draftHash();
    if (h === lastDraftHash) return;
    lastDraftHash = h;
    queueLeadSnapshot(buildFD('Draft'));
  }
  var earlyDraftTimer;
  function scheduleDraftSnapshot() {
    clearTimeout(earlyDraftTimer);
    if (hasPhoneForSending()) earlyDraftTimer = setTimeout(sendDraftSnapshot, 3000);
  }
  // Capture the latest completed details promptly, even when the phone number
  // was typed before the name/address. This remains a Draft until submission.
  form.addEventListener('input', scheduleDraftSnapshot);
  form.addEventListener('change', scheduleDraftSnapshot);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') { focusCount++; flushLeadQueue(); } else sendAbandonedLead();
  });
  window.addEventListener('pagehide', sendAbandonedLead);
  setInterval(function () {
    if (!formSubmitted && hasPhoneForSending() && Date.now() - lastInteraction > 120000) sendAbandonedLead();
  }, 30000);
  setInterval(sendDraftSnapshot, 25000);

  /*********** Submit ***********/
  function clearFieldError(el, messageId) {
    if (el) { el.classList.remove('is-invalid'); el.removeAttribute('aria-invalid'); }
    if ($(messageId)) $(messageId).hidden = true;
  }
  form.elements['Sa-Name'].addEventListener('input', function () { clearFieldError(this, 'nameMessage'); });
  if (wilayaEl) wilayaEl.addEventListener('change', function () { clearFieldError(this, 'wilayaMessage'); });
  function fail(el, msg) {
    if (el) { el.classList.add('is-invalid'); el.setAttribute('aria-invalid', 'true'); el.focus(); el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    if (msg && el === phoneInput) showPhoneMsg(msg);
    var message = el === wilayaEl ? $('wilayaMessage') : el === form.elements['Sa-Name'] ? $('nameMessage') : null;
    if (message) { message.textContent = msg; message.hidden = false; }
    sendAttemptedIfNeeded();
  }
  function restoreControls() {
    controlsBeforeSubmit.forEach(function (item) { item.el.disabled = item.disabled; });
    controlsBeforeSubmit = [];
    formSubmitted = false;
    form.removeAttribute('aria-busy');
    btn.innerHTML = btnHTML;
    if (variants.length) updateVariant(false);
    else updateSubmitState();
  }
  function networkError(message) {
    $('formNetworkError').textContent = message;
    $('formNetworkError').style.display = 'block';
    if ($('formNetworkHelp')) $('formNetworkHelp').hidden = false;
  }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (formSubmitted || btn.disabled || form.dataset.codReady !== 'true') return;

    var trap = $('Sa-Bot-Trap');
    botTrapHit = !!(trap && trap.value);

    var nameEl = form.elements['Sa-Name'];
    if (!nameEl.value.trim()) return fail(nameEl, 'أدخل اسمك حتى نتمكن من تأكيد الطلب معك.');
    nameEl.value = nameEl.value.trim();
    clearFieldError(nameEl, 'nameMessage');
    if (!hasPhoneForSending()) { updatePhoneUI(true); return fail(phoneInput); }
    if (wilayaEl && !wilayaEl.value) return fail(wilayaEl, 'اختر ولايتك من القائمة.');
    clearFieldError(wilayaEl, 'wilayaMessage');

    // Capture before disabling controls (disabled inputs are omitted by FormData).
    var record = recordFor(buildFD('Submitted'));
    if (Object.prototype.hasOwnProperty.call(record.payload, 'Sa-Delivery-Fee') && deliveryAmount(record.payload['Sa-Delivery-Fee']) === null) {
      fail(wilayaEl, deliveryQuote().available ? 'تعذّر تجهيز الطلب لهذه الولاية. يمكنك الاتصال بنا لإتمام الطلب.'
        : 'الطلب غير متاح لهذه الولاية حالياً. يمكنك الاتصال بنا للاستفسار.');
      if ($('formNetworkHelp')) $('formNetworkHelp').hidden = false;
      return;
    }
    // A retry retains the accepted snapshot and its original quote, even if
    // the merchant has since changed delivery prices. Do not alter its ID.
    showDeliveryQuote(Number(record.payload['Sa-Subtotal'] || record.payload['Sa-Total']) || 0,
      deliveryAmount(record.payload['Sa-Delivery-Fee']));
    var savedLocally = hasReceipt(record) || saveRecord(record);
    activeOrder = record;
    formSubmitted = true;
    controlsBeforeSubmit = Array.from(form.querySelectorAll('input, select, button'), function (el) {
      var item = { el: el, disabled: el.disabled }; el.disabled = true; return item;
    });
    form.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    btn.innerHTML = '<span class="cod-spinner" aria-hidden="true"></span><span>جاري إرسال طلبيتك...</span>';
    $('formNetworkError').style.display = 'none';
    if ($('formNetworkHelp')) $('formNetworkHelp').hidden = true;
    if ($('formRecoveryStatus')) $('formRecoveryStatus').hidden = true;

    // A slow answer (Google busy, weak network): after 5 s tell the customer the
    // order is on its way, so they wait instead of closing the page.
    var slowNotice = setTimeout(function () {
      if (formSubmitted && !submissionConfirmed && activeOrder === record) {
        btn.innerHTML = '<span class="cod-spinner" aria-hidden="true"></span><span>لحظة… طلبك قيد الإرسال، لا تغلق الصفحة</span>';
      }
    }, 5000);
    sendOrder(record)
      .then(function () {
        clearTimeout(slowNotice);
        submissionConfirmed = true;
        form.removeAttribute('aria-busy');
        btn.innerHTML = '<span>✅ تم إرسال طلبك</span>';
        redirectToThankYou(record);
      })
      .catch(function (error) {
        clearTimeout(slowNotice);
        restoreControls();
        var message = error.message === 'offline'
          ? 'لا يوجد اتصال بالإنترنت. اتصل بالإنترنت ثم اضغط على الزر للتحقق من الطلب.'
          : error.message === 'in-progress'
            ? 'يجري إرسال هذا الطلب في صفحة أخرى مفتوحة. انتظر تأكيدها قبل المحاولة مجدداً.'
            : 'تعذر تأكيد وصول طلبك. معلوماتك ما زالت هنا؛ اضغط على الزر للتحقق من الطلب أو اتصل بنا للتأكد.';
        if (!savedLocally) message += ' لا تغلق هذه الصفحة قبل تأكيد الطلب.';
        networkError(message);
        updateRecovery();
      });
  });

  // Mobile browsers can restore the disabled successful form from BFCache.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    if (submissionConfirmed || !activeOrder || !inFlightOrders[activeOrder.payload['Sa-Event-Id']]) {
      // Returning from thank-you must not label the unchanged confirmed order
      // as a fresh abandoned lead. Editing its details creates a new snapshot.
      if (submissionConfirmed) lastDraftHash = lastAttemptHash = lastAbandonedHash = draftHash();
      restoreControls();
      submissionConfirmed = false;
      // Keep the confirmed identity so an unchanged click returns its receipt;
      // editing a business field still creates a fresh order via fingerprint.
      if (!activeOrder || !hasReceipt(activeOrder)) activeOrder = null;
      $('formNetworkError').style.display = 'none';
      if ($('formNetworkHelp')) $('formNetworkHelp').hidden = true;
      updateRecovery();
    }
  });

  /*********** Sticky bars ***********/
  var orderSection = $('orderSection');
  var stickyBar = $('stickyBar');
  function scrollToForm() {
    var nameEl = form.elements['Sa-Name'];
    var next = !nameEl.value.trim() ? nameEl : !hasPhoneForSending() ? phoneInput : wilayaEl && !wilayaEl.value ? wilayaEl : btn;
    if (next) next.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { if (next && !next.disabled) next.focus({ preventScroll: true }); }, 450);
  }
  window.scrollToForm = scrollToForm;
  document.querySelectorAll('[data-scroll-to-form]').forEach(function (b) { b.addEventListener('click', scrollToForm); });

  if ('IntersectionObserver' in window) {
    // Keep the shortcut available until the actual submit button is visible.
    if (orderSection && stickyBar) {
      new IntersectionObserver(function (entries) {
        stickyBar.classList.toggle('visible', !entries[0].isIntersecting);
      }, { threshold: 0 }).observe(btn);
    }
    // Top title+price bar: once the price has scrolled away
    var head = $('codStickyHead');
    var priceBlock = $('codPriceBlock');
    if (head && priceBlock) {
      new IntersectionObserver(function (entries) {
        var hidden = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        head.classList.toggle('is-visible', hidden);
      }, { threshold: 0 }).observe(priceBlock);
    }
  }

  // Enable submission only after all handlers and recovery paths are ready.
  if (APPS_SCRIPT_URL && typeof fetch === 'function') {
    form.dataset.codReady = 'true';
    if ($('formStartupStatus')) $('formStartupStatus').hidden = true;
    restoreControls();
    // Back reloaded this page with the details of an order already confirmed in
    // this tab: show «عرض طلبك» and send no follow-up draft for it.
    var tabOrder = confirmedRecordFor(currentOrderFingerprint());
    if (tabOrder && !activeOrder) {
      activeOrder = tabOrder;
      lastDraftHash = lastAttemptHash = lastAbandonedHash = draftHash();
    }
    updateRecovery();
    updatePhoneUI(false);
    setTimeout(function () { sendDraftSnapshot(); flushLeadQueue(); }, 0);
  }
})();
